<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Nova Previsão Orçamentária</v-toolbar-title>
                <v-spacer/>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formCadastro" ref="formCadastro" v-model="valid" lazy-validation >
                    <v-row dense>
                        <v-col cols="12" md="4">
                            <v-text-field :disabled="item.id > 0" type="number" v-model.number="item.ano" label="Ano" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select :disabled="item.id > 0" v-model="item.despesa" label="Tipo" :items="tipos" item-value="id" item-text="nome" @change="carregarPlanoContas()" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row dense style="width: 100% !important;">
                        <v-col cols="12" class="pa-0">
                            <v-data-table dense :headers="headerPlanoContas" :items="planoContas" group-by="planoConta.descricao" item-key="index" :items-per-page="-1" hide-default-footer>
                                <template v-slot:group.header="{items, isOpen, toggle}">
                                    <!-- PLANOCONTA -->
                                    <th>
                                        <v-icon @click="toggle">
                                            {{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
                                        </v-icon>
                                        {{ items[0].planoConta.descricao }}
                                    </th>
                                    <td class="text-right">{{ somatorio(items[0].planoConta, 'janeiro').toMoeda(false) }}</td>
                                    <td class="text-right">{{ somatorio(items[0].planoConta, 'fevereiro').toMoeda(false) }}</td>
                                    <td class="text-right">{{ somatorio(items[0].planoConta, 'marco').toMoeda(false) }}</td>
                                    <td class="text-right">{{ somatorio(items[0].planoConta, 'abril').toMoeda(false) }}</td>
                                    <td class="text-right">{{ somatorio(items[0].planoConta, 'maio').toMoeda(false) }}</td>
                                    <td class="text-right">{{ somatorio(items[0].planoConta, 'junho').toMoeda(false) }}</td>
                                    <td class="text-right">{{ somatorio(items[0].planoConta, 'julho').toMoeda(false) }}</td>
                                    <td class="text-right">{{ somatorio(items[0].planoConta, 'agosto').toMoeda(false) }}</td>
                                    <td class="text-right">{{ somatorio(items[0].planoConta, 'setembro').toMoeda(false) }}</td>
                                    <td class="text-right">{{ somatorio(items[0].planoConta, 'outubro').toMoeda(false) }}</td>
                                    <td class="text-right">{{ somatorio(items[0].planoConta, 'novembro').toMoeda(false) }}</td>
                                    <td class="text-right">{{ somatorio(items[0].planoConta, 'dezembro').toMoeda(false) }}</td>
                                    <td class="text-right">{{ somatorio(items[0].planoConta, 'total').toMoeda(false) }}</td>
                                </template>

                                <template v-slot:[`item.valor.janeiro`]="{ item }">
                                    <v-text-field type="number" v-model.number="item.valor.janeiro" reverse dense/>
                                </template>

                                <template v-slot:[`item.valor.fevereiro`]="{ item }">
                                    <v-text-field type="number" v-model.number="item.valor.fevereiro" reverse dense/>
                                </template>

                                <template v-slot:[`item.valor.marco`]="{ item }">
                                    <v-text-field type="number" v-model.number="item.valor.marco" reverse dense/>
                                </template>

                                <template v-slot:[`item.valor.abril`]="{ item }">
                                    <v-text-field type="number" v-model.number="item.valor.abril" reverse dense/>
                                </template>

                                <template v-slot:[`item.valor.maio`]="{ item }">
                                    <v-text-field type="number" v-model.number="item.valor.maio" reverse dense/>
                                </template>

                                <template v-slot:[`item.valor.junho`]="{ item }">
                                    <v-text-field type="number" v-model.number="item.valor.junho" reverse dense/>
                                </template>

                                <template v-slot:[`item.valor.julho`]="{ item }">
                                    <v-text-field type="number" v-model.number="item.valor.julho" reverse dense/>
                                </template>

                                <template v-slot:[`item.valor.agosto`]="{ item }">
                                    <v-text-field type="number" v-model.number="item.valor.agosto" reverse dense/>
                                </template>

                                <template v-slot:[`item.valor.setembro`]="{ item }">
                                    <v-text-field type="number" v-model.number="item.valor.setembro" reverse dense/>
                                </template>

                                <template v-slot:[`item.valor.outubro`]="{ item }">
                                    <v-text-field type="number" v-model.number="item.valor.outubro" reverse dense/>
                                </template>

                                <template v-slot:[`item.valor.novembro`]="{ item }">
                                    <v-text-field type="number" v-model.number="item.valor.novembro" reverse dense/>
                                </template>

                                <template v-slot:[`item.valor.dezembro`]="{ item }">
                                    <v-text-field type="number" v-model.number="item.valor.dezembro" reverse dense/>
                                </template>

                                <template v-slot:[`item.valor.total`]="{ item }">
                                    <div class="text-right">
                                        {{ item.valor.total.toMoeda(false) }}
                                    </div>
                                </template>

                            </v-data-table>
                            <!-- <v-simple-table dense style="width: 100% !important;">
                                <thead>
                                    <tr>
                                        <th class="text-center">Plano Conta</th>
                                        <th class="text-center">Janeiro</th>
                                        <th class="text-center">Fevereiro</th>
                                        <th class="text-center">Março</th>
                                        <th class="text-center">Abril</th>
                                        <th class="text-center">Maio</th>
                                        <th class="text-center">Junho</th>
                                        <th class="text-center">Julho</th>
                                        <th class="text-center">Agosto</th>
                                        <th class="text-center">Setembro</th>
                                        <th class="text-center">Outubro</th>
                                        <th class="text-center">Novembro</th>
                                        <th class="text-center">Dezembro</th>
                                        <th class="text-center">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(conta, index) in item.planoContas" :key="index">
                                        <td :style="true ? `font-size: 10px !important; font-weight: bold;` : `font-size: 10px !important;`">{{ conta.planoConta.descricao }}</td>
                                        <td><v-text-field type="number" v-model.number="conta.valor.janeiro" dense @change="AtualizaItem(conta)" :disabled="!conta.check"/></td>
                                        <td><v-text-field type="number" v-model.number="conta.valor.fevereiro" dense @change="AtualizaItem(conta)" :disabled="!conta.check"/></td>
                                        <td><v-text-field type="number" v-model.number="conta.valor.marco" dense @change="AtualizaItem(conta)" :disabled="!conta.check"/></td>
                                        <td><v-text-field type="number" v-model.number="conta.valor.abril" dense @change="AtualizaItem(conta)" :disabled="!conta.check"/></td>
                                        <td><v-text-field type="number" v-model.number="conta.valor.maio" dense @change="AtualizaItem(conta)" :disabled="!conta.check"/></td>
                                        <td><v-text-field type="number" v-model.number="conta.valor.junho" dense @change="AtualizaItem(conta)" :disabled="!conta.check"/></td>
                                        <td><v-text-field type="number" v-model.number="conta.valor.julho" dense @change="AtualizaItem(conta)" :disabled="!conta.check"/></td>
                                        <td><v-text-field type="number" v-model.number="conta.valor.agosto" dense @change="AtualizaItem(conta)" :disabled="!conta.check"/></td>
                                        <td><v-text-field type="number" v-model.number="conta.valor.setembro" dense @change="AtualizaItem(conta)" :disabled="!conta.check"/></td>
                                        <td><v-text-field type="number" v-model.number="conta.valor.outubro" dense @change="AtualizaItem(conta)" :disabled="!conta.check"/></td>
                                        <td><v-text-field type="number" v-model.number="conta.valor.novembro" dense @change="AtualizaItem(conta)" :disabled="!conta.check"/></td>
                                        <td><v-text-field type="number" v-model.number="conta.valor.dezembro" dense @change="AtualizaItem(conta)" :disabled="!conta.check"/></td>
                                        <td><v-text-field type="number" v-model.number="conta.valor.total" dense disabled/></td>
                                    </tr>
                                </tbody>
                            </v-simple-table> -->
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>

import { OrcamentoService } from '@/core/services/financeiro'
import { Orcamento, OrcamentoItem } from '@/core/domain/financeiro'
import PlanoContaService from '../../../core/services/financeiro/PlanoContaService';
import PlanoConta from '../../../core/domain/financeiro/PlanoConta';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() { 
            if ('formCadastro' in this.$refs)
                this.$refs.formCadastro.resetValidation();
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if(this.dialog){
                this.carregar();
                this.carregarPlanoContas();
            }
            else{
                this.$emit('fechou');
            }
        }
    },
    data: () => ({
        planoContas: [],
        service: new OrcamentoService(),
        servicePlanoConta: new PlanoContaService(),
        planoContas: [],
        valid: true,
        dialog: false,
        isLoading: false,
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        salvando: false,
        tipos: [
            { id: true, nome: "Despesa"},
            { id: false, nome: "Receita"}
        ],
        headerPlanoContas: [
            { text: 'Plano Conta', value: 'planoContaItem.descricao', },
            { text: 'Janeiro', value: 'valor.janeiro', type: 'number', align: 'end' },
            { text: 'Fevereiro', value: 'valor.fevereiro', type: 'number', align: 'end' },
            { text: 'Março', value: 'valor.marco', type: 'number', align: 'end' },
            { text: 'Abril', value: 'valor.abril', type: 'number', align: 'end' },
            { text: 'Maio', value: 'valor.maio', type: 'number', align: 'end' },
            { text: 'Junho', value: 'valor.junho', type: 'number', align: 'end' },
            { text: 'Julho', value: 'valor.julho', type: 'number', align: 'end' },
            { text: 'Agosto', value: 'valor.agosto', type: 'number', align: 'end' },
            { text: 'Setembro', value: 'valor.setembro', type: 'number', align: 'end' },
            { text: 'Outubro', value: 'valor.outubro', type: 'number', align: 'end' },
            { text: 'Novembro', value: 'valor.novembro', type: 'number', align: 'end' },
            { text: 'Dezembro', value: 'valor.dezembro', type: 'number', align: 'end' },
            { text: 'Total', value: 'valor.total', type: 'number', align: 'end' }
        ]
    }),
    methods: {
        somatorio(tenant, mes){
            return this.item.planoContas.filter(x => x.planoContaId == tenant.id).reduce((a, b) => a + b.valor[mes], 0);
        },
        carregar(){
            if(this.item.id > 0){
                this.planoContas = this.item.planoContas;
                this.ordernar();
            }
        },
        carregarPlanoContas(){
            if(this.item.id == 0)
                this.planoContas = [];

            this.salvando = true
            this.servicePlanoConta.ListarByTipo(this.item.despesa ? 'd' : 'r', "Itens").then(
                res => {
                    let planoContas = res.data.items;
                    planoContas.forEach(planoConta => {
                        planoConta.itens.forEach(item => {
                            let registro = new OrcamentoItem();
                            registro.planoContaId = planoConta.id;
                            registro.planoConta = planoConta;
                            registro.planoContaItemId = item.id;
                            registro.planoContaItem = item;
                            //ADICIONA TODOS
                            if(this.item.id == 0){
                                this.planoContas.push(registro);
                            }
                            //ADICIONA APENAS O QUE FALTA CASO CADASTRE UM NOVO
                            else if (!this.planoContas.find(x => x.planoContaId == registro.planoContaId && x.planoContaItemId == registro.planoContaItemId)){
                                this.planoContas.push(registro);
                            }   
                        });
                    });

                    this.ordernar();
                },
                err => this.$swal('Aviso', err.message, 'error')
            ).finally(() => {
                this.salvando = false;
            })
        },
        ordernar(){
            this.planoContas.sort((a, b) => {
                if(a.planoContaId < b.planoContaId){
                    return -1;
                }
                if(a.planoContaId > b.planoContaId){
                    return 1;
                }

                if(a.planoContaItemId < b.planoContaItemId){
                    return -1;
                }
                if(a.planoContaItemId > b.planoContaItemId){
                    return 1;
                }
                
                return 0;
            });
        },
        save() {
            if (this.$refs.formCadastro.validate()) {
                this.salvando = true;
                let modelo = new Orcamento(this.item);
                modelo.planoContas = [];
                this.service.Salvar(modelo).then(
                    res => {
                        let id = res.data.id ? res.data.id : this.item.id;
                        this.service.GerenciarItens(id, this.planoContas);
                        this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                        this.$emit('salvou');
                        this.close();
                    }, 
                    err =>  {
                        this.$swal('Aviso', err.response.data.title ? err.response.data.title : err.response.data, err.response.status == 400 ? 'warning' : 'error');
                    }
                ).finally(() => {
                    this.salvando = false;
                })
            }
        },
        close() {
            this.planoContas = [];
            this.dialog = false;
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {
        
    }
}
</script>